import { useEffect, useState } from 'react';

import { useWindowSize } from '@/hooks/useWindowSize';
import { Article } from '@/types/Article';
import { Category } from '@/types/Category';

export const useArticleLeadImage = (article: Article) => {
  const { width = 0 } = useWindowSize();
  const [heroImage, setHeroImage] = useState<string | undefined>(
    article.leadImage || article.leadPortraitImage
  );
  useEffect(() => {
    if (width <= 768) {
      setHeroImage(article.leadPortraitImage || article.leadImage);
    } else {
      setHeroImage(article.leadImage || article.leadPortraitImage);
    }
  }, [width, article]);
  return heroImage;
};

export const useCategoryLeadImage = (category: Category) => {
  const { width = 0 } = useWindowSize();
  const [heroImage, setHeroImage] = useState<string | undefined>(
    category.image || category.landscapeImage
  );
  useEffect(() => {
    if (width <= 768) {
      setHeroImage(category.landscapeImage || category.image);
    } else {
      setHeroImage(category.image || category.landscapeImage);
    }
  }, [width, category]);
  return heroImage;
};
